export default __webpack_public_path__ + "static/media/Ojo-cerrado.ec6547cb.svg";